'use client'

import { createContext, useContext } from 'react'

/**
 * `openPathInSplit` on its own context. Transcript components (markdown
 * links, tool cards) need only this one stable callback; reading it through
 * `useGlobalChat()` re-rendered every link and card in the transcript on any
 * chat-state change (an email attached from the canvas, the panel toggled,
 * a tab switched). `GlobalChatProvider` supplies it; outside the provider it
 * reads `undefined` and links fall back to plain navigation.
 */
export const OpenPathInSplitContext = createContext<
  ((path: string) => void) | undefined
>(undefined)

export function useOpenPathInSplit(): ((path: string) => void) | undefined {
  return useContext(OpenPathInSplitContext)
}

/** Canonical route corrections retain an open panel without opening a closed one. */
export const ReplacePathPreservingSplitContext = createContext<
  ((path: string) => void) | undefined
>(undefined)

export function useReplacePathPreservingSplit() {
  return useContext(ReplacePathPreservingSplitContext)
}
